import React from 'react';

import { useField } from 'formik';
import RangeField from '..';

const RangeFieldMemo = React.memo(RangeField);

const RangeFieldCFormik = (props) => {
	const { name } = props;
	const [field, meta] = useField(name);

	if (!name) return 'For RangeField connected to Formik name is required!';

	return (
		<RangeFieldMemo
			value={field.value}
			onChange={field.onChange}
			onBlur={field.onBlur}
			error={(meta.touched || meta.initialTouched) && meta.error}
			{...props}
		/>
	);
};

RangeFieldCFormik.propTypes = {
	...RangeField.propTypes,
};

export default RangeFieldCFormik;
